/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Login_Methods_Self_WarningInputs */



/**
* | output |
* | --- |
* | "You are changing your own sign-in methods." |
*
* @param {Member_Login_Methods_Self_WarningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_login_methods_self_warning = /** @type {((inputs?: Member_Login_Methods_Self_WarningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Login_Methods_Self_WarningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie ändern Ihre eigenen Anmeldemethoden.")
	return /** @type {LocalizedString} */ ("You are changing your own sign-in methods.")
});